module.exports = __webpack_public_path__ + "img/germany-cancer-female.1a5c716e.png";